<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">
        <ng-container [ngSwitch]="this.mode">
          <ng-container *ngSwitchCase="'reprint'">Reprint Tags</ng-container>
          <ng-container *ngSwitchCase="'void'">Void Batch</ng-container>
          <ng-container *ngSwitchDefault>Batch Actions</ng-container>
        </ng-container>
      </h2>
      <div class="modal-subtitle" *ngIf="this.detail">
        {{"Lot" | tenantWords}} {{this.detail.lotNumber}}<ng-container *ngIf="this.detail.itemName"> · {{this.detail.itemName}}</ng-container>
      </div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading" [ngSwitch]="this.mode">

    <div class="option-list" *ngSwitchCase="'menu'">
      <button type="button" class="option-card" (click)="setMode('reprint')">
        <span class="option-icon"><fa-icon [icon]="faTags"></fa-icon></span>
        <span class="option-text">
          <span class="option-name">Reprint Tags</span>
          <span class="option-sub">Send this batch's tags to a printer again</span>
        </span>
        <fa-icon [icon]="faChevronRight" class="option-chevron"></fa-icon>
      </button>
      <button type="button" class="option-card danger" (click)="setMode('void')">
        <span class="option-icon"><fa-icon [icon]="faTrash"></fa-icon></span>
        <span class="option-text">
          <span class="option-name">Void Batch</span>
          <span class="option-sub">Remove this batch's barcodes from inventory</span>
        </span>
        <fa-icon [icon]="faChevronRight" class="option-chevron"></fa-icon>
      </button>
    </div>

    <ng-container *ngSwitchCase="'reprint'">
      <printer-selector (selectionChanged)="setPrinter($event)"></printer-selector>
    </ng-container>

    <ng-container *ngSwitchCase="'void'">
      <div class="warning-note void-warning" role="note">
        <fa-icon [icon]="faTriangleExclamation"></fa-icon>
        <span>{{this.voidMessage}}</span>
      </div>

      <mat-form-field appearance="outline" class="reason-field">
        <mat-label>{{"Reason" | tenantWords}}</mat-label>
        <mat-select id="reason" [(ngModel)]="this.reasonCodeId" name="reason" required>
          <mat-option *ngFor="let re of this.transactionReasons" [value]="re.id">
            {{re.reason}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>

  <div class="modal-footer" [ngSwitch]="this.mode">
    <ng-container *ngSwitchCase="'menu'">
      <button mat-stroked-button type="button" (click)="close()">Close</button>
    </ng-container>

    <ng-container *ngSwitchCase="'reprint'">
      <button mat-stroked-button type="button" (click)="setMode('menu')">Back</button>
      <button mat-raised-button color="primary" type="button" [disabled]="!this.printer?.id || this.isLoading" (click)="reprintTags()">
        <fa-icon [icon]="faPrint" class="me-2"></fa-icon>Print
      </button>
    </ng-container>

    <ng-container *ngSwitchCase="'void'">
      <button mat-stroked-button type="button" (click)="setMode('menu')">Back</button>
      <button mat-raised-button color="warn" type="button" [disabled]="!this.reasonCodeId || this.isLoading" (click)="voidBatch()">
        <fa-icon [icon]="faTrash" class="me-2"></fa-icon>Void Batch
      </button>
    </ng-container>
  </div>

</div>
